import * as tslib_1 from "tslib";
import { Filter3DCompositeTask } from "./tasks/Filter3DCompositeTask";
import { Filter3DBase } from "./Filter3DBase";
var CompositeFilter3D = (function (_super) {
    tslib_1.__extends(CompositeFilter3D, _super);
    /**
     * Creates a new CompositeFilter3D object
     * @param blurX The amount of horizontal blur to apply
     * @param blurY The amount of vertical blur to apply
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function CompositeFilter3D(blendMode, exposure) {
        if (exposure === void 0) { exposure = 1; }
        var _this = _super.call(this) || this;
        _this._compositeTask = new Filter3DCompositeTask(blendMode, exposure);
        _this.addTask(_this._compositeTask);
        return _this;
    }
    Object.defineProperty(CompositeFilter3D.prototype, "exposure", {
        get: function () {
            return this._compositeTask.exposure;
        },
        set: function (value) {
            this._compositeTask.exposure = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompositeFilter3D.prototype, "overlayTexture", {
        get: function () {
            return this._compositeTask.overlayTexture;
        },
        set: function (value) {
            this._compositeTask.overlayTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    return CompositeFilter3D;
}(Filter3DBase));
export { CompositeFilter3D };



// WEBPACK FOOTER //
// ../dist/lib/filters/CompositeFilter3D.js